import React, { createContext, useContext, useState, useEffect } from 'react';
import supabase from '../supabase/supabase';

const GlobalSettingsContext = createContext();

export const useGlobalSettings = () => {
  const context = useContext(GlobalSettingsContext);
  if (!context) throw new Error('useGlobalSettings must be used within a GlobalSettingsProvider');
  return context;
};

export const GlobalSettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({
    productionUrl: 'https://site2rent.netlify.app',
    supportEmail: 'support@site2rent.com',
    maintenanceMode: false,
    promotedAdsCount: 3 // Valoarea "X" setabilă de admin
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchRemoteSettings();
  }, []);

  const fetchRemoteSettings = async () => {
    try {
      const { data, error } = await supabase.from('admin_settings_1780601000000').select('*');
      if (data) {
        const remoteSettings = {};
        data.forEach(item => {
          remoteSettings[item.key] = item.value;
        });
        
        // Merge local storage defaults with remote DB settings
        const local = localStorage.getItem('site2rent_global_settings');
        const localParsed = local ? JSON.parse(local) : {};
        
        setSettings(prev => ({
          ...prev,
          ...localParsed,
          promotedAdsCount: remoteSettings.promoted_ads_count || prev.promotedAdsCount
        }));
      }
    } catch (e) {
      console.error('Failed to load settings', e);
    } finally {
      setLoading(false);
    }
  };

  const updateSettings = async (newSettings) => {
    const updated = { ...settings, ...newSettings };
    setSettings(updated);
    localStorage.setItem('site2rent_global_settings', JSON.stringify(updated));

    // Persist promoted count to Supabase if changed
    if (newSettings.promotedAdsCount !== undefined) {
      await supabase.from('admin_settings_1780601000000').upsert({
        key: 'promoted_ads_count',
        value: parseInt(newSettings.promotedAdsCount)
      });
    }
  };

  return (
    <GlobalSettingsContext.Provider value={{ settings, updateSettings, loading, refresh: fetchRemoteSettings }}>
      {children}
    </GlobalSettingsContext.Provider>
  );
};